/* eslint-disable react/no-multi-comp */
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { format, parse, startOfMonth, set } from "date-fns";
import { ptBR } from "date-fns/esm/locale";

import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import ErrorOutline from "@material-ui/icons/ErrorOutline";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableHead from "@material-ui/core/TableHead";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import LinearProgress from "@material-ui/core/LinearProgress";
import Input from "../../components/Input/Input";

import axios from "../../config/axiosInstance";

import ModalDetails from "./modalDetails";

const actionsStyles = (theme) => ({
  root: {
    flexShrink: 0,
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing(2.5),
  },
  recordsTable: {
    display: "flex",
    alignItems: "center",
  },
  lastRecords: {
    width: 10,
    height: 10,
    borderRadius: 50,
    padingRigth: 10,
    float: "left",
    marginRight: 8,
    display: "flex",
    alignItems: "flex-end",
  },
});

class TablePaginationActions extends React.Component {
  handleFirstPageButtonClick = (event) => {
    this.props.onChangePage(event, 0);
  };

  handleBackButtonClick = (event) => {
    this.props.onChangePage(event, this.props.page - 1);
  };

  handleNextButtonClick = (event) => {
    this.props.onChangePage(event, this.props.page + 1);
  };

  handleLastPageButtonClick = (event) => {
    this.props.onChangePage(
      event,
      Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) - 1)
    );
  };

  render() {
    const { classes, count, page, rowsPerPage, theme } = this.props;

    return (
      <div className={classes.root}>
        <IconButton
          onClick={this.handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="First Page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={this.handleBackButtonClick}
          disabled={page === 0}
          aria-label="Previous Page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={this.handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="Next Page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        <IconButton
          onClick={this.handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="Last Page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </div>
    );
  }
}

TablePaginationActions.propTypes = {
  classes: PropTypes.object.isRequired,
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  theme: PropTypes.object.isRequired,
};

const TablePaginationActionsWrapped = withStyles(actionsStyles, {
  withTheme: true,
})(TablePaginationActions);

const styles = (theme) => ({
  root: {
    width: "100%",
    borderRadius:20
  },
  table: {
    minWidth: 500,
  },
  tableWrapper: {
    overflowX: "auto",
  },
});

class CustomPaginationActionsTable extends React.Component {
  state = {
    rows: [],
    page: 0,
    rowsPerPage: 5,
    startDate: startOfMonth(new Date()),
    endDate: set(new Date(), { hours: 23, minutes: 59, seconds: 59 }),
    openDetails: false,
    data: null,
  };

  componentDidMount() {
    this.fetchRecords();
  }

  fetchRecords = () => {
    this.setState({ loading: true });
    const start = format(this.state.startDate, "yyyy-MM-dd");
    const end = format(this.state.endDate, "yyyy-MM-dd");
    this.props.absences(this.props.token,start,end)
    return axios
      .post(
        // "/timeSheet/generate/pointSheet/app/v3?type=RECORDS",
        "/timeclocks/timeclocksInPeriod",
        { start, end },
        {
         headers: { Authorization: `Bearer ${this.props.token}` },
        }
      )
      .then((response) => {
        this.setState({ rows: response.data, loading: false });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleCloseDetails = () => {
    this.setState({ openDetails: false });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ page: 0, rowsPerPage: event.target.value });
  };

  handleInputChange = (name, event) => {
    if (event.target) {
      this.setState({ [name]: event.target.value }, () => this.fetchRecords());
    } else {
      this.setState({ [name]: event }, () => this.fetchRecords());
    }
  };

  render() {
    const { classes ,absences} = this.props;
    const { rows, rowsPerPage, page, startDate, endDate } = this.state;
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

    const setColor = (type) => (type === "I" ? "#79D478" : "#FC7C7C");

    const setDate = (dtRegister) => {
      const dtRef = new Date(dtRegister)
      const dayforat = dtRef.getDate().toString().padStart(2, '0'); // Dia com zero à esquerda
      const monthformat = (dtRef.getMonth() + 1).toString().padStart(2, '0'); // Mês com zero à esquerda
      const yearformat = dtRef.getFullYear();
      
      const formattedDate = `${dayforat}/${monthformat}/${yearformat}`;
      const date = parse(formattedDate, "dd/MM/yyyy", new Date());
      // const date = new Date(dtRegister);
      const dayName = format(date, "EEE", { locale: ptBR });
      const day = format(date, "dd", { locale: ptBR });
      const month = format(date, "MMMM", { locale: ptBR });
      const year = format(date, "yyyy", { locale: ptBR });
      const dayDetails = `${dayName}, ${day} de ${month} de ${year}`;
      return dayDetails;
    };

    return (
      <Paper elevation={2} className={classes.root}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <Typography variant="body1">Registros</Typography>
              </TableCell>
              <TableCell align="right">
                <Input
                  elementType="datePicker"
                  label="Início do período"
                  margin="normal"
                  value={startDate}
                  onChange={(event) =>
                    this.handleInputChange("startDate", event)
                  }
                  style={{ maxWidth: "160px" }}
                />
                <Input
                  elementType="datePicker"
                  label="Fim do período"
                  margin="normal"
                  value={endDate}
                  style={{ marginLeft: 10, maxWidth: "160px" }}
                  onChange={(event) => this.handleInputChange("endDate", event)}
                />
              </TableCell>
            </TableRow>
          </TableHead>
        </Table>

        <div className={classes.tableWrapper}>
          <Table className={classes.table}>
            <TableHead>
              {this.state.loading ? (
                <tr>
                  <TableCell padding="none">
                    <LinearProgress />
                  </TableCell>
                </tr>
              ) : null}
            </TableHead>
            <TableBody>
              {rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => (
                  <TableRow key={row.id}>
                    <TableCell component="th" scope="row">
                      <div className={classes.recordsTable}>
                        <Button
                          onClick={() =>
                            this.setState({ openDetails: true, data: row })
                          }
                          style={{ width: 340, justifyContent: "unset" }}
                        >
                          <div
                            style={{
                              background: setColor(row.timeclock.type),
                              width: 10,
                              height: 10,
                              borderRadius: 50,
                              padingRigth: 10,
                              float: "left",
                              marginRight: 8,
                              display: "flex",
                              alignItems: "flex-end",
                            }}
                          />
                          {/* {new Date(row.timeclock.dtRegister).getHours() < 10 ? '0' + new Date(row.timeclock.dtRegister).getHours() + ':' + new Date(row.timeclock.dtRegister).getMinutes() : new Date(row.timeclock.dtRegister).getHours() + ':' + new Date(row.timeclock.dtRegister).getMinutes()} */}
                          {new Date(row.timeclock.dtRegister).getUTCHours().toString().padStart(2, '0') + ':' + new Date(row.timeclock.dtRegister).getUTCMinutes().toString().padStart(2, '0')}
                          <span
                            style={{
                              color: "rgba(0, 0, 0, 0.54)",
                              textTransform: "lowercase",
                              paddingLeft: 5,
                            }}
                          >
                            {setDate(row.timeclock.dtRegister)}
                          </span>

                          {row.hasLocationRestrictDivergence ||
                          row.markOffScaleDivergence ||
                          row.hasPhotoRequiredDivergence ? (
                            <ErrorOutline
                              style={{ marginLeft: 15, fontSize: 18 }}
                              color="secondary"
                            />
                          ) : (
                            ""
                          )}
                        </Button>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              {emptyRows > 0 && (
                <TableRow style={{ height: 48 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5]}
                  colSpan={3}
                  count={rows.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  SelectProps={{
                    native: true,
                  }}
                  onChangePage={this.handleChangePage}
                  onChangeRowsPerPage={this.handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActionsWrapped}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </div>
        <ModalDetails
          open={this.state.openDetails}
          handleClose={this.handleCloseDetails}
          data={this.state.data}
        />
      </Paper>
    );
  }
}

CustomPaginationActionsTable.propTypes = {
  classes: PropTypes.object.isRequired,
  absences: PropTypes.func
};

const mapStateToProps = (state) => ({
  token: state.auth.token,
});

export default connect(mapStateToProps)(
  withStyles(styles)(CustomPaginationActionsTable)
);
